<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="operations" style="margin-top: 5px">
        <div class="triggers">
          <div>
            <el-button type="primary" no="1" @click="toQuery">{{ $t('FileHistory.Refresh') }}</el-button>
            <!--v-permission="['button_FileHistory_fileUpload']" 未生效 权限先不加上-->
            <el-button type="primary" no="2" @click="cloudFile.visible=true">{{ $t('FileHistory.Upload') }}</el-button>
            <!--v-permission="['button_FileHistory_fileDelete']" 未生效 权限先不加上-->
            <el-button type="danger" no="3" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
            <el-button type="primary" no="4" @click="download">{{ $t('FileHistory.BatchDownload') }}</el-button>
            <el-button v-if="ingotUploadButton" type="primary" no="5">{{ $t('FileHistory.ingotUpload') }}</el-button>
            <el-button v-if="ingotButton" type="primary" no="6">{{ $t('FileHistory.ingotLog') }}</el-button>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="flex:1;width:100%;height:100%;"
          no="7"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
    </div>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      no="8"
      @uploadDone="updateSop"
    />
    <el-dialog
      v-if="isShowingDetailForm"
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="isShowingDetailForm"
      :title="showDetailTitle"
      append-to-body
      width="200px;"
    >
      <div style="display: flex;flex-direction: column;height: 350px">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptionsFileDetail"
          :column-defs="columnDefsFileDetail"
          :row-data="rowDataFileDetail"
          style="flex:1;width:100%;height: 100%"
          no="9"
          @gridReady="params=>gridApiFileDetail=params.api"
        />
      </div>
    </el-dialog>

  </div>
</template>

<script>
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import URL from '@/api/urlTranslator'
import { getFileList, deleteFile, saveMetaData } from '@/api/storage'
import { cacheName, cache } from '@/utils/cacheManager'
import { Project } from '@/class/model/pm/Project'
import { DocumentManage } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { sortByMultiField } from '@/utils'

export default {
  name: 'TabFileHistory',
  components: { cargoCloudFileUpload },
  props: {
    context: {
      type: Object,
      required: false
    }
  },
  data: function() {
    return {
      ingotButton: false,
      ingotUploadButton: false,
      user: {},
      storageURL: '',
      fileTypeMap: new Map(),
      docType: [],
      job: null,
      fileName: '',
      fileIdList: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          minWidth: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              return true
            }
          }
        }
      },
      columnDefs: [
        {
          headerName: this.$t('FileHistory.fileVersion'),
          field: 'fileVersion',
          width: 100
        },
        {
          headerName: this.$t('FileHistory.jobType'),
          field: 'fileType',
          width: 100,
          cellRenderer: params => {
            return this.fileTypeLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.fileType'),
          field: 'fileFormat',
          width: 100
        },
        {
          headerName: this.$t('FileHistory.fileSize'),
          field: 'fileSize',
          width: 100,
          cellRenderer: params => {
            return this.fileSizeColumnLabel(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.createdBy'),
          field: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('FileHistory.createdDate'),
          field: 'createDate',
          width: 100
        },
        {
          headerName: this.$t('FileHistory.Details'),
          field: 'fileId',
          width: 100,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('popFileHistoryDetailFormDialog')
            return `<a onclick="${methodPath}('${params.value}')" style="color:#46a6ff">${this.$t('FileHistory.Details')}</a>`
          }
        },
        {
          headerName: this.$t('FileHistory.view'),
          field: 'fileId',
          width: 100,
          cellRenderer: params => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:#46a6ff">${this.$t('FileHistory.view')}</a>`
          }
          /* cellRenderer: params => {
            return `<a href="${this.storageURL}file/open/${params.value}?sessionId=${this.context.user.sessionId}" target="_blank" style="color:#46a6ff">{{$t('FileHistory.view')}}</a>`
          }*/
        }
      ],
      rowData: [],
      gridApi: null,
      gridApiFileDetail: null,
      gridOptionsFileDetail: {
        context: {
          componentParent: this
        }
      },
      columnDefsFileDetail: [
        {
          headerName: this.$t('FileHistory.tagName'),
          field: 'key',
          width: 150
        },
        {
          headerName: this.$t('FileHistory.tagValue'),
          field: 'val',
          width: 200
        }
      ],
      rowDataFileDetail: [],
      cloudFile: {
        visible: false,
        job: new Project(),
        lob: 'other'
      },
      isShowingDetailForm: false,
      showDetailTitle: '',
      documentManage: new DocumentManage(),
      isAllowedEdit: true
    }
  },
  created() {
  },
  beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async preloadBasicData(uuid) {
      this.rowData = []
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.configMap = cache.config
      this.cloudFile.job.uuid = uuid
      this.toQuery()
    },
    /* 转换文件类型中文名称*/
    fileTypeLabelFunction: function(value) {
      return this.$t('ProjectManage.Others')
    },
    /* 文件大小转换*/
    fileSizeColumnLabel: function(value) {
      if (value !== '' && !isNaN(value)) {
        return (value / 1024).toFixed(2) + ' KB'
      }
      return ''
    },
    updateSop(documentTypeUuid) {
      this.toQuery()
    },
    toQuery: async function() {
      if (!this.cloudFile.job.uuid || this.cloudFile.job.uuid === undefined) {
        return
      }
      this.storageURL = this.configMap.get('StorageURL')
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' +
        this.cloudFile.job.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      await getFileList(xmlParam).then(res => {
        this.rowData = Array.from(res.data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize,
            fileVersion: p.fileVersion || '',
            createDate: p.createDate,
            createChineseName: p.extendMetaData.createChineseName || '',
            createdBy: p.extendMetaData.createdBy,
            extendMetaData: p.extendMetaData,
            fileNameBak: p.fileName,
            path: '',
            hasParent: false,
            parentId: ''

          }
        })
      })
      this.getFilesSucceedHandler()
    },
    /* 文件列表 父级和子级组装*/
    getFilesSucceedHandler: function() {
      this.rowData = sortByMultiField(this.rowData, ['fileName', 'fileVersion', 'createDate'], true)
      if (!this.rowData || this.rowData.length === 0) {
        return
      }
      let fatherFile = this.rowData[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < this.rowData.length; i++) {
        childFile = this.rowData[i]
        if (childFile.fileName === fatherFile.fileName) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
          // childFile.fileName = ''
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      this.rowData = source
    },
    onFileView(value) {
      var fileObject = this.rowData.find(x => x.fileId === value)
      // 测试 编辑保存
      // this.itemEditEndHandler(fileObject)

      // 判断是否有下载文件的权限
      if (this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject)) {
          return
        }
      }
      const url = `${URL.common.findByFileId}/${value}?sessionId=${this.user.sessionId}`
      window.open(url)
    },
    checkDownloadFile(data) {
      if (Number(data.createdBy) !== this.user.userId) {
        this.$message.warning(this.$t('ProjectManage.YouToViewOrFiles'))
        return false
      }
      return true
    },
    checkFileDocTypeRole(data) {
      let documentType = data.extendMetaData.documentType
      if (documentType === '其他') {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      const result = this.getDocType(documentType)
      if (result === null || result.length === 0) {
        return true
      }

      if (this.user.admin || parseInt(data.createdBy) === this.user.userId) {
        return true
      }

      const fileRoleMap = this.getFileRoleMap(result)
      if (fileRoleMap.length === 0) {
        this.$message.info('[' + data.fileName + ']文件不允许任何人查看或下载.')
        return false
      }
      let isView = false
      if (this.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
        isView = true
      }
      if (this.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
        isView = true
      }
      if (!isView && fileRoleMap.indexOf('all') !== -1) {
        isView = true
      }
      if (!isView) {
        this.$message.info('你没有权限查看或下载[' + data.fileName + ']文件')
        return
      }
    },
    //  文档属性权限
    getFileRoleMap(result) {
      const fileRoleMap = []
      if (this.getDocTypeRole('sales', result)) {
        fileRoleMap.push('sales')
      }
      if (this.getDocTypeRole('op', result)) {
        fileRoleMap.push('op')
      }
      if (this.getDocTypeRole('all', result)) {
        fileRoleMap.push('all')
      }
      return fileRoleMap
    },
    // 文件类型 编辑保存
    itemEditEndHandler(item) {
      // TODO 前端界面grid 文件类型下拉框公共控件未开发  入参已组装
      const documentType = item.extendMetaData['documentType']
      const documentName = item.extendMetaData['documentName']
      const isShared = item.extendMetaData['isShared']
      const op = item.extendMetaData['op']
      const sales = item.extendMetaData['sales']
      const all = item.extendMetaData['other']
      const customer = item.extendMetaData['customer']
      const consignee = item.extendMetaData['consignee']
      const shipper = item.extendMetaData['shipper']
      const destinationAgent = item.extendMetaData['destinationAgent']
      const bookingAgent = item.extendMetaData['bookingAgent']
      const xmlParam = `<RequestObject>
      <fileId>${item.fileId}</fileId>
      <extendMetaData>
      <entry>
      <key>documentType</key>
      <value>${documentType}</value>
      </entry>
      <entry>
      <key>documentName</key>
      <value>${documentName}</value>
      </entry>
      <entry>
      <key>isShared</key>
      <value>${isShared}</value>
      </entry>
      <entry>
      <key>op</key>
      <value>${op}</value>
      </entry>
      <entry>
      <key>sales</key>
      <value>${sales}</value>
      </entry>
      <entry>
      <key>all</key>
      <value>${all}</value>
      </entry>
      <entry>
      <key>customer</key>
      <value>${customer}</value>
      </entry>
      <entry>
      <key>consignee</key>
      <value>${consignee}</value>
      </entry>
      <entry>
      <key>shipper</key>
      <value>${shipper}</value>
      </entry>
      <entry>
      <key>destinationAgent</key>
      <value>${destinationAgent}</value>
      </entry>
      <entry>
        <key>bookingAgent</key>
        <value>${bookingAgent}</value>
        </entry>
        </extendMetaData>
        </RequestObject>`
      saveMetaData(xmlParam)
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        try {
          for (const item of rows) {
            const isSuccess = await deleteFile(item.fileId).then(res => res.data === 'success')
            if (isSuccess) {
              item.isDeleted = true
            } else {
              break
            }
          }
        } finally {
          this.rowData = this.rowData.filter(p => !p.isDeleted)
        }
      }).catch(() => {
      })
    },
    download() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // 判断是否有权限
      this.validate(rows)
      if (rows.length === 1) {
        window.open(`${URL.common.findByFileId}/${rows[0].fileId}?sessionId=${this.user.sessionId}`)
      } else {
        const fileIds = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
        const fileName = this.cloudFile.job.projectName + '.zip'
        window.open(`${URL.common.compressFiles}?sessionId=${this.user.sessionId}&fileIds=${fileIds}&fileName=${fileName}`)
      }
    },
    validate(fileList) {
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        for (const file of fileList) {
          if (!this.checkDownloadFile(file)) {
            return false
          }
        }
      }
      for (const file of fileList) {
        if (file.extendMetaData.hasOwnProperty('documentType')) {
          return this.checkFileDocTypeRole(file)
        }
      }
      return
    },
    // 查看详情
    popFileHistoryDetailFormDialog: function(value) {
      this.isShowingDetailForm = true
      var fileObject = this.rowData.find(x => x.fileId === value)
      const extendMetaData = fileObject.extendMetaData
      this.showDetailTitle = fileObject.fileName + '_' + fileObject.fileVersion

      const roles = ['op', 'sales', 'all', 'customer', 'consignee', 'shipper', 'destinationAgent', 'bookingAgent']

      var docTypeFilter = null
      // 文件类型转换
      if (extendMetaData.hasOwnProperty('documentType')) {
        var documentType = extendMetaData.documentType
        if (documentType === '其他') {
          documentType = 'OTHER'
        }
        if (documentType === 'other' || documentType === 'Other') {
          documentType = documentType.toLocaleUpperCase()
        }
        //  根据文件类型code 获取相关属性
        docTypeFilter = this.getDocType(documentType)
      }

      const extendMetaDataSort = this.objKeySort(extendMetaData)
      const tempFileDetailList = []
      for (var key in extendMetaDataSort) {
        if (key === 'entry' || key === 'createdBy') {
          continue
        }
        var keyValue
        if (roles.includes(key) && docTypeFilter != null) {
          keyValue = this.getDocTypeRole(key, docTypeFilter) ? this.$t(`SeaExport.Accessible`) : ''
        } else {
          keyValue = extendMetaData[key]
        }
        const convertKeyName = this.keyLabFunc(key)

        var keyName
        keyName = this.$t(`SeaExport.${convertKeyName}`)
        if (keyName === 'SeaExport.') {
          keyName = key
        }
        /* 资源文件未转义 特殊处理直接赋值*/
        if (keyName === 'SeaExport.bookingAgent') {
          keyName = '订舱代理'
        }
        const json = { 'key': keyName, 'val': keyValue }
        tempFileDetailList.push(json)
      }
      this.rowDataFileDetail = tempFileDetailList
    },
    // 获取 获取属性访问权限
    getDocTypeRole(roleKey, docType) {
      if (docType === null || docType.length === 0) {
        return false
      }
      if (roleKey === 'all') {
        roleKey = 'other'
      }
      for (var i = 0; i < docType.length; i++) {
        if (docType[i][roleKey]) {
          return true
        }
      }

      return false
    },
    // 获取code所关联的XML 原cargo getDocTypeXml
    getDocType(codes) {
      const docTypeFilter = []
      if (codes == null || codes === '') {
        return null
      }
      var codeArray = codes.split(',')
      for (let i = 0; i < codeArray.length; i++) {
        var docObject = this.docType.find(x => x.code === codeArray[i])
        if (docObject != null) {
          docTypeFilter.push(docObject)
        }
      }
      return docTypeFilter
    },
    /* json 根据 key 的名称排序的函数*/
    objKeySort(obj) {
      var newkey = Object.keys(obj).sort()
      var newObj = {}
      for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = obj[newkey[i]]
      }
      return newObj
    },
    // 转换对应的 中文定义的keyName
    keyLabFunc(value) {
      var convertKeyName = ''
      switch (value) {
        case 'op':
          convertKeyName = 'Operation'
          break
        case 'sales':
          convertKeyName = 'Sales'
          break
        case 'all':
          convertKeyName = 'AllPositions'
          break
        case 'customer':
          convertKeyName = 'ConsignationCompany'
          break
        case 'consignee':
          convertKeyName = 'Consignee'
          break
        case 'shipper':
          convertKeyName = 'Shipper'
          break
        case 'destinationAgent':
          convertKeyName = 'DestinationAgent'
          break
        case 'bookingAgent':
          convertKeyName = 'bookingAgent'
          break
      }
      return convertKeyName
    }
  }
}
</script>

<style scoped>

</style>
